import React from "react"
import ReactDOM from "react-dom/client"
import { LockedPage } from "@app/scripts/react-early-access/components/LockedPage"
import { VipProvider } from "@app/scripts/react-providers/locales-vip"

class EarylAccess extends HTMLElement {
  // Add state variables
  isLocked = false
  accessCode = ''
  handle = ''

  constructor() {
    super();
    this.setIsLocked = this.setIsLocked.bind(this)
    this.setAccessCode = this.setAccessCode.bind(this)
    this.setHandle = this.setHandle.bind(this)
  }

  setIsLocked(value: boolean) {
  
    if(this.isLocked && !value) {
      const date = new Date()
      date.setTime(date.getTime() + (24*60*60*1000)) // Set the cookie expiration date to 24 hours from now
      document.cookie = `unlocked_${this.handle}=true; expires=${date.toUTCString()}; path=/`
      this.isLocked = false

      window.location.reload()
    } else {
      this.isLocked = value
    }
  
    this.updateComponent()
  }

  setAccessCode(code: string) {
    this.accessCode = code
  }

  setHandle(handle: string) {
    this.handle = handle
  }

  updateComponent() { 
    if (this.isLocked) {
      const root = ReactDOM.createRoot(this)
      root.render(
        <VipProvider isCollection={false}>
          <LockedPage isCollection={false} code={this.accessCode} setIsLocked={this.setIsLocked} />
        </VipProvider>
      )
    }
  }

  connectedCallback() {
    const handle = this.getAttribute("current-page")
    const metafileds = document.getElementById("custom-metafields")

    if (!metafileds || !metafileds.textContent) return

    if (handle) this.setHandle(handle)
    
    const { unlockDate, earlyAccessCode, customer } = JSON.parse(metafileds.textContent)
    const lockedState = document.cookie.split('; ').find(row => row.startsWith(`unlocked_${handle}`))
    const isUnocked = lockedState && lockedState.split('=')[1] === 'true'

    if (earlyAccessCode && isUnocked) return
      
    if (unlockDate && new Date(unlockDate) > new Date() && !customer) {
      this.setIsLocked(true)
    }
    if (earlyAccessCode) {
      this.setAccessCode(earlyAccessCode)
      this.setIsLocked(true)

      // Get the 'code' parameter from the current URL
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams) {
        const codeParam = urlParams.get('code')

        // Check if the 'code' parameter matches 'earlyAccessCode'
        if (codeParam && codeParam === earlyAccessCode) {
          this.setIsLocked(false)
        }
      }
    } else {
      document.cookie = `unlocked_${handle}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
    }

    this.updateComponent()

  }
}

customElements.define("early-access", EarylAccess)
